import { ExternalId } from './ExternalId'

import camelCaseKeys from 'camelcase-keys'

export class Booking {
  constructor (params = {}) {
    const {
      id,
      sequence,
      externalIds,
      profile,
      profileId,
      checkin,
      checkout,
      account,
      accountId,
      facility,
      facilityId,
      type,
      typeId,
      locator
    } = camelCaseKeys(params, { deep: true })
    this.id = id || null
    this.sequence = sequence || null
    this.externalIds = externalIds ? externalIds.map((e) => new ExternalId(e)) : []
    this.profileId = profileId || null
    this.profile = profile || this.profileId
    this.checkin = checkin || null
    this.checkout = checkout || null
    this.accountId = accountId || null
    this.account = account || this.accountId
    this.facilityId = facilityId || null
    this.facility = facility || this.facilityId
    this.typeId = typeId || null
    this.type = type || this.typeId
    this.locator = locator || null
  }
  serialize (editedFields) {
    var item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      facilityId: item.facilityId,
      profileId: item.profileId,
      typeId: item.typeId,
      checkin: item.checkin,
      checkout: item.checkout,
      accountId: item.accountId
    }
  }
}
